/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
// import { OpenQrCodeService } from './../../../core/services/shared-services/open-qrcode/open-qr-code.service';
// import { UserService } from './../../../core/services/user/user/user.service';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { FileUploadService } from "valuchaincommon/common-services/file-upload.service";
// import { MatSnackBarService } from 'src/app/core/services/shared-services/mat-snack-bar/mat-snack-bar.service';
import { DomSanitizer } from "@angular/platform-browser";
// import { NgxImageCompressService } from 'ngx-image-compress';
import { ToastrService } from "ngx-toastr";
// import { ImagesService } from 'src/app/core/services/images/images.service';
import { icons } from "src/environments/config";
import { environment } from "src/environments/environment";
import { ImagesService } from "src/app/services/images/images.service";
import { DeviceDetectorService } from "ngx-device-detector";
import { SlotService } from "src/app/services/slot/slot.service";

@Component({
  selector: "vc-profile-image",
  templateUrl: "./profile-image.component.html",
  styleUrls: ["./profile-image.component.scss"],
})
export class ProfileImageComponent implements OnInit, OnChanges {
  @ViewChild("video", { static: false }) videoElement: ElementRef;
  @ViewChild("canvas", { static: false }) canvas: ElementRef;

  @Input() profileImage;
  @Input() fromTemplates;
  @Input() qrCode;
  @Input() editMode;
  @Input() editImage;
  @Input() refresh;
  @Input() maxSize;
  @Input() paymentDump;
  @Input() isQuote;
  @Input() coverImage;
  @Input() boardImage;
  @Input() wallImage;
  @Input() floorImage;
  @Input() noMedia;
  @Input() itemCreation;
  @Input() isAudio;
  @Input() ispdf;
  @Input() bUnit;
  @Input() isSingle;
  @Input() isCollectionBoard;
  @Input() type;
  @Input() currentLimit;
  @Input() productCreation;
  @Input() isRoomPlan;
  @Output() imageData = new EventEmitter();
  @Output() deleteImageData = new EventEmitter();
  @Input() titleText;
  public captureImage = false;
  public profileImageData = new FormData();
  public previewProfileImageUrl: any = "";
  public defaultProfileImage = "";
  flag = false;
  isMobileBoard = false;
  blob;
  templateImageFileType = ["image/png", "image/jpg", "image/jpeg"];
  videoWidth = 0;
  videoHeight = 0;
  stream: any;
  constraints = {
    video: {
      facingMode: "environment",
      width: { ideal: 4096 },
      height: { ideal: 2160 },
    },
  };
  imageBoardPath = "";
  imageText = false;
  isMobile = false;

  constructor(
    public renderer: Renderer2,
    // public imageCompress: NgxImageCompressService,
    // public openQrCodeService: OpenQrCodeService,
    // public snackbar: MatSnackBarService,
    private deviceInfo: DeviceDetectorService,
    private element: ElementRef,
    public fileUploadService: FileUploadService,
    public sanitizer: DomSanitizer,
    public imagesService: ImagesService,
    public toastrService: ToastrService,
    public slotService: SlotService // public imagesService: ImagesService, // public userService: UserService
  ) {
    this.isMobile = this.deviceInfo.isMobile();
  }

  ngOnInit() {
    if (this.slotService.isMobileDevices()) {
      this.isMobileBoard = true;
    }
    if (this.type === "businessuser") {
      this.defaultProfileImage = icons.businessUserIcon.defaultImg;
    } else {
      this.defaultProfileImage = icons.businessUnitIcon.defaultImg;
    }

    if (this.profileImage !== undefined) {
      this.previewProfileImageUrl = this.profileImage;
    } else {
      this.previewProfileImageUrl = this.defaultProfileImage;
    }
    if (this.editImage) {
      this.imageBoardPath = this.editImage;
    }
    if (this.currentLimit === undefined) {
      this.currentLimit = Number.MAX_SAFE_INTEGER;
    }
  }

  ngOnChanges(changes) {
    if (changes.refresh && changes.refresh.previousValue !== undefined) {
      this.previewProfileImageUrl = this.defaultProfileImage;
      this.profileImageData.delete("files");
    }
  }

  // Preview profile image on select an image
  onSelectProfileImage(event) {
    if (event.target.files && event.target.files.length) {
      let splitStr = event.target.files[0].name.split(".");
      if (
        event.target.files[0].type.startsWith("image/") &&
        !(this.isAudio || this.ispdf)
      ) {
        if (
          this.coverImage ||
          this.boardImage ||
          this.paymentDump ||
          this.productCreation ||
          this.isQuote ||
          this.wallImage ||
          this.floorImage
        ) {
          if (
            this.fromTemplates &&
            !this.templateImageFileType.includes(event.target.files[0].type)
          ) {
            this.toastrService.error("Invalid file type", null, {
              timeOut: 2000,
            });
            return;
          }
          if (this.itemCreation && this.noMedia) {
            this.toastrService.error("Invalid file type", null, {
              timeOut: 2000,
            });
            return;
          }
          this.onFileChange(event);
        } else {
          if (
            this.fromTemplates &&
            !this.templateImageFileType.includes(event.target.files[0].type)
          ) {
            this.toastrService.error("Invalid file type", null, {
              timeOut: 2000,
            });
            return;
          }
          this.assignFormData(event.target.files[0]);
        }
      } else if (
        (this.fileUploadService.audioFormats.includes(
          "." + splitStr[splitStr.length - 1].toLowerCase()
        ) &&
          this.isAudio) ||
        (event.target.files[0].type.startsWith("application/") &&
          (this.paymentDump || this.isQuote)) ||
        (splitStr[splitStr.length - 1].toLowerCase() === "glb" &&
          this.productCreation &&
          this.noMedia) ||
        (splitStr[splitStr.length - 1].toLowerCase() === "pdf" && this.ispdf)
      ) {
        this.onFileChange(event);
      } else {
        this.toastrService.error("Invalid file type", null, { timeOut: 2000 });
        // this.snackbar.errorMessage(
        //   "Invalid file type",
        //   "Close",
        //   2000,
        //   "bottom",
        //   "end"
        // );
      }
    }
  }

  onFileChange(e) {
    this.blob = e;
    const element = e.target;
    for (
      var i = 0;
      i < Math.min(this.currentLimit, element.files.length);
      i++
    ) {
      const formData = new FormData();
      formData.append("file", element.files[i]);
      const attributes = this.element.nativeElement.attributes;
      const filename = element.files[i].name;
      console.log(element.files[i].size / (1024 * 1024));
      if (
        this.maxSize &&
        element.files[i].size / (1024 * 1024) > this.maxSize
      ) {
        this.imageData.emit({
          error: "Size should be less than " + this.maxSize + "MB",
        });
      } else {
        this.fileUploadService
          .addFiles(attributes, formData)
          .subscribe((data: any) => {
            this.imageBoardPath = this.imagesService.getImageURL(data.imageURI);
            this.imageData.emit({
              name: filename,
              imageServerURL: this.imagesService.getImageURL(data.imageURI),
              thumbnailImageURL: data.thumbnailImageURL,
              blobFile: this.blob,
            });
          });
      }
    }
    if (this.currentLimit < element.files.length) {
      this.toastrService.error(
        `Maximum number of files that can be uploaded is ${
          this.isRoomPlan ? 36 : 10
        }`,
        null,
        { timeOut: 2000 }
      );
    }
  }

  getImagePath(image) {
    return this.imagesService.getImageURL(image);
  }
  deleteImage() {
    this.imageBoardPath = "";
    this.deleteImageData.emit(null);
  }

  assignFormData(file) {
    this.profileImageData = new FormData();
    this.profileImageData.append("files", file);
    console.log(this.profileImageData.getAll("files"));

    const reader: any = new FileReader();

    reader.readAsDataURL(file); // read file as data url

    reader.onload = (event) => {
      this.previewProfileImageUrl = this.sanitizer.bypassSecurityTrustUrl(
        event.target.result
      );
    };

    this.imageData.emit(this.profileImageData);
    this.flag = true;
  }

  // delete profile image
  deleteProfileImage() {
    this.previewProfileImageUrl = this.defaultProfileImage;
    this.profileImageData.delete("files");
    this.imageData.emit(this.profileImageData);
  }

  // check for camera and display error if camera not found
  startCamera() {
    this.captureImage = true;
    setTimeout(() => {
      this.constraints.video.width = this.videoElement.nativeElement.parentNode.offsetWidth;
      this.constraints.video.height = this.videoElement.nativeElement.parentNode.offsetHeight;
      if (!!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
        navigator.mediaDevices
          .getUserMedia(this.constraints)
          .then(this.attachVideo.bind(this))
          .catch(this.handleError);
      } else {
        alert("Sorry, camera not available.");
      }
    }, 100);
  }

  // attaching the video recording
  attachVideo(stream) {
    this.stream = stream;
    this.renderer.setProperty(
      this.videoElement.nativeElement,
      "srcObject",
      stream
    );
    this.renderer.listen(this.videoElement.nativeElement, "play", (event) => {
      this.videoHeight = this.videoElement.nativeElement.videoHeight;
      this.videoWidth = this.videoElement.nativeElement.videoWidth;
    });
  }

  // error condition
  handleError(error) {
    console.log("Error: ", error);
  }

  // capturing the image
  capture() {
    this.renderer.setProperty(
      this.canvas.nativeElement,
      "width",
      this.videoWidth
    );
    this.renderer.setProperty(
      this.canvas.nativeElement,
      "height",
      this.videoHeight
    );
    this.canvas.nativeElement
      .getContext("2d")
      .drawImage(this.videoElement.nativeElement, 0, 0);

    const imageBlob = this.dataURItoBlob(
      this.canvas.nativeElement.toDataURL("image/jpeg").split("base64,")[1]
    );
    const imageFile = new File([imageBlob], "profileImage.jpeg", {
      type: "image/jpeg",
    });
    this.assignFormData(imageFile);
    this.closeCapturing();

    // this.imageCompress
    // .compressFile(this.canvas.nativeElement.toDataURL("image/jpeg"), 50, 50)
    // .then(result => {
    //   const imageBlob = this.dataURItoBlob(result.split("base64,")[1]);
    //   const imageFile = new File([imageBlob], "profileImage.jpeg", {
    //     type: "image/jpeg"
    //   });
    //   this.assignFormData(imageFile);
    //   this.closeCapturing();
    // });
  }

  // converting base64 URI to input file object
  dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI);
    const int8Array = new Uint8Array(new ArrayBuffer(byteString.length));
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: "image/jpeg" });
    return blob;
  }

  async switchCamera() {
    if (!this.stream) {
      return;
    }
    console.log(this.stream.getVideoTracks()[0].getSettings());
    const currentMode = this.stream.getVideoTracks()[0].getSettings()
      .facingMode;
    console.log(currentMode);
    const newMode = currentMode === "environment" ? "user" : "environment";
    this.constraints.video.facingMode = newMode;
    console.log(this.constraints);
    this.stream.getTracks().forEach((track) => track.stop());
    this.startCamera();
  }

  closeCapturing() {
    this.captureImage = false;
    if (this.stream) {
      this.stream.getTracks().forEach((track) => track.stop());
    }
  }

  // show QR code on clicking on it
  //   showImage(imageURL) {
  //     this.imagesService.viewProductImages([{ image: imageURL }], false);
  //   }

  //   showQr_code(dataURL) {
  //     this.openQrCodeService.onClick_qrCode(dataURL);
  //   }
}
